import React, { FC } from 'react';

import { EVINCED_SEVERITIES, EvSeverityBadge } from '@evinced-private/ui-common';

import { normalizeSeverity } from 'src/common/components/severity-cell-formatter/SeverityCellFormatterHelper';

interface ISeverityTagProps {
	severity: EVINCED_SEVERITIES | string;
}

export const SeverityTag: FC<ISeverityTagProps> = ({ severity }) => {
	if (!severity) {
		return null;
	}

	const normalizedSeverity = normalizeSeverity(severity);

	return (
		<EvSeverityBadge
			variant={normalizedSeverity}
			screenReaderText={{
				prefix: 'Severity: '
			}}
		/>
	);
};
